import { ApiMembership, ApiGatewayMembershipStatus, ApiMembershipProduct, ApiUser } from '@tytapp/api';

export interface TestScenario {
    id: string;
    label: string;
    description: string;
    membership: Partial<ApiMembership>;
    entitleUser?: boolean;
    user?: Partial<ApiUser>;
}

export const TEST_SCENARIOS : TestScenario[] = [
    {
        id: 'nonmember',
        label: 'No Membership',
        description: `
            The user has never had membership.
        `,
        membership: null
    }, {
        id: 'involuntary-canceled',
        label: 'Canceled (Involuntary)',
        description: `
            All renewal attempts failed and the membership is now expired
        `,
        membership: {
            gateway_name: 'stripe',
            purchased_at: '2019-11-15',
            entitled: <any>false,
            active: false,
            payment_source: 'Mastercard **1234',
            payment_status: 'canceled',
            price: 499,
            status: <any><Partial<ApiGatewayMembershipStatus>>{
                renewal_due_date: new Date('2019-11-20').toISOString(),
                next_charge_amount: 499,
                next_charge_date: new Date('2019-11-20').toISOString(),
                in_good_standing: true,
                canceled: true,
                cancel_at_period_end: true,
                past_due: false
            },
            product: <any><Partial<ApiMembershipProduct>>{
                name: 'Insider Monthly',
                price: 499,
                dollar_price: 4.99,
                description: 'This is the description of Insider Monthly (test scenario)',
                id: 123,
                product_sku: 'insider_monthly',
                period: 'monthly',
                rank: 0
            }
        }
    }, {
        id: 'voluntary-canceled',
        label: 'Canceled (Voluntary)',
        description: `
            The user canceled their membership and it is now expired
        `,
        membership: {
            gateway_name: 'stripe',
            purchased_at: '2019-11-15',
            entitled: <any>false,
            active: false,
            payment_source: 'Mastercard **1234',
            payment_status: 'canceled',
            cancelled_at: '2019-11-17',
            price: 499,

            status: <any><Partial<ApiGatewayMembershipStatus>>{
                renewal_due_date: new Date('2019-11-20').toISOString(),
                next_charge_amount: 499,
                next_charge_date: new Date('2019-11-20').toISOString(),
                in_good_standing: true,
                canceled: true,
                cancel_at_period_end: true,
                past_due: false
            },
            product: <any><Partial<ApiMembershipProduct>>{
                name: 'Insider Monthly',
                price: 499,
                dollar_price: 4.99,
                description: 'This is the description of Insider Monthly (test scenario)',
                id: 123,
                product_sku: 'insider_monthly',
                period: 'monthly',
                rank: 0
            }
        }
    },
    {
        id: 'entitled-but-not-entitled',
        label: 'Entitled But Not Entitled',
        description: `
            The user's current membership is not entitled, but they have an additional
            membership which entitles them.
        `,
        membership: {
            gateway_name: 'stripe',
            purchased_at: '2019-11-15',
            entitled: <any>false,
            active: false,
            payment_source: 'Mastercard **1234',
            payment_status: 'expired',
            cancelled_at: '2019-11-17',
            refunded_at: '2019-11-18',
            renews_on: '2020-11-14',
            price: 499,

            status: <any><Partial<ApiGatewayMembershipStatus>>{
                renewal_due_date: new Date('2019-11-20').toISOString(),
                next_charge_amount: 499,
                next_charge_date: new Date('2019-11-20').toISOString(),
                in_good_standing: true,
                canceled: true,
                cancel_at_period_end: true,
                past_due: false
            },
            product: <any><Partial<ApiMembershipProduct>>{
                name: 'Insider Monthly',
                price: 499,
                dollar_price: 4.99,
                description: 'This is the description of Insider Monthly (test scenario)',
                id: 123,
                product_sku: 'insider_monthly',
                period: 'monthly',
                rank: 0
            }
        }
    },
    {
        id: 'voluntary-canceled-refunded',
        label: 'Canceled + Refunded (Voluntary)',
        description: `
            The user canceled + refunded their membership and it is now expired
        `,
        membership: {
            gateway_name: 'stripe',
            purchased_at: '2019-11-15',
            entitled: <any>false,
            active: false,
            payment_source: 'Mastercard **1234',
            payment_status: 'expired',
            cancelled_at: '2019-11-17',
            refunded_at: '2019-11-18',
            renews_on: '2020-11-14',
            price: 499,

            status: <any><Partial<ApiGatewayMembershipStatus>>{
                renewal_due_date: new Date('2019-11-20').toISOString(),
                next_charge_amount: 499,
                next_charge_date: new Date('2019-11-20').toISOString(),
                in_good_standing: true,
                canceled: true,
                cancel_at_period_end: true,
                past_due: false
            },
            product: <any><Partial<ApiMembershipProduct>>{
                name: 'Insider Monthly',
                price: 499,
                dollar_price: 4.99,
                description: 'This is the description of Insider Monthly (test scenario)',
                id: 123,
                product_sku: 'insider_monthly',
                period: 'monthly',
                rank: 0
            }
        }
    },
    {
        id: 'canceling',
        label: 'Canceling (Voluntary)',
        description: `
            The user has canceled, but are still entitled
        `,
        membership: {
            gateway_name: 'stripe',
            purchased_at: '2019-11-15',
            entitled: <any>true,
            active: true,
            payment_source: 'Mastercard **1234',
            payment_status: 'canceling',
            cancelled_at: new Date(Date.now()-1000*60*60*24*2).toISOString(),
            renews_on: new Date(Date.now()+1000*60*60*24*5).toISOString(),
            price: 499,
            status: <any><Partial<ApiGatewayMembershipStatus>>{
                renewal_due_date: new Date(Date.now()+1000*60*60*24*5).toISOString(),
                next_charge_amount: 499,
                next_charge_date: new Date(Date.now()+1000*60*60*24*5).toISOString(),
                in_good_standing: true,
                canceled: false,
                cancel_at_period_end: true,
                past_due: false
            },
            product: <any><Partial<ApiMembershipProduct>>{
                name: 'Insider Monthly',
                price: 499,
                dollar_price: 4.99,
                description: 'This is the description of Insider Monthly (test scenario)',
                id: 123,
                product_sku: 'insider_monthly',
                period: 'monthly',
                rank: 0
            }
        }
    }, {
        id: 'gift-recurring',
        label: 'Recurring Gift',
        description: `
            The user has a recurring gift membership
        `,
        membership: {
            gateway_name: 'stripe',
            purchased_at: '2019-11-15',
            created_at: '2019-11-15 00:00:00',
            entitled: <any>true,
            active: true,
            payment_source: 'Mastercard **1234',
            payment_status: 'good_standing',
            cancelled_at: undefined,
            renews_on: new Date(Date.now()+1000*60*60*24*5).toISOString(),
            price: 499,
            status: <any><Partial<ApiGatewayMembershipStatus>>{
                renewal_due_date: new Date(Date.now()+1000*60*60*24*5).toISOString(),
                next_charge_amount: 499,
                next_charge_date: new Date(Date.now()+1000*60*60*24*5).toISOString(),
                in_good_standing: true,
                canceled: false,
                cancel_at_period_end: true,
                past_due: false
            },
            gift_item: {
                code: 'abcdef',
                created_at: '2024-01-01 00:00:00',
                gift_message: 'You rock!',
                purchaser_name: 'Jimmy'

            },
            product: <any><Partial<ApiMembershipProduct>>{
                name: 'Insider Monthly',
                price: 499,
                dollar_price: 4.99,
                description: 'This is the description of Insider Monthly (test scenario)',
                id: 123,
                product_sku: 'insider_monthly',
                period: 'monthly',
                rank: 0
            }
        }
    },  {
        id: 'gift-recurring',
        label: 'Recurring Sponsorship',
        description: `
            The user a recurring gift sponsorship
        `,
        membership: {
            gateway_name: 'stripe',
            purchased_at: '2019-11-15',
            created_at: '2019-11-15 00:00:00',
            entitled: <any>true,
            active: true,
            payment_source: 'Mastercard **1234',
            payment_status: 'good_standing',
            cancelled_at: undefined,
            renews_on: new Date(Date.now()+1000*60*60*24*5).toISOString(),
            price: 499,
            status: <any><Partial<ApiGatewayMembershipStatus>>{
                renewal_due_date: new Date(Date.now()+1000*60*60*24*5).toISOString(),
                next_charge_amount: 499,
                next_charge_date: new Date(Date.now()+1000*60*60*24*5).toISOString(),
                in_good_standing: true,
                canceled: false,
                cancel_at_period_end: true,
                past_due: false
            },
            gift_item: {
                code: 'abcdef',
                created_at: '2024-01-01 00:00:00',
                gift_message: 'You rock!',
                purchaser_name: 'Jimmy',
                sponsorship: true
            },
            product: <any><Partial<ApiMembershipProduct>>{
                name: 'Insider Monthly',
                price: 499,
                dollar_price: 4.99,
                description: 'This is the description of Insider Monthly (test scenario)',
                id: 123,
                product_sku: 'insider_monthly',
                period: 'monthly',
                rank: 0
            }
        }
    }, {
        id: 'past_due',
        label: 'Past Due',
        description: `
            User is past due on renewal
        `,
        membership: {
            gateway_name: 'stripe',
            purchased_at: '2019-11-15',
            entitled: <any>true,
            active: true,
            payment_source: 'Mastercard **1234',
            payment_status: 'past_due',
            renews_on: new Date(Date.now()-1000*60*60*24*2).toISOString(),
            price: 499,
            status: <any><Partial<ApiGatewayMembershipStatus>>{
                renewal_due_date: new Date(Date.now()-1000*60*60*24*2).toISOString(),
                next_charge_amount: 499,
                next_charge_date: new Date(Date.now()-1000*60*60*24*2).toISOString(),
                in_good_standing: true,
                canceled: false,
                cancel_at_period_end: true,
                revocation_date: new Date(Date.now()+1000*60*60*24*12).toISOString(),
                past_due: true
            },
            product: <any><Partial<ApiMembershipProduct>>{
                name: 'Insider Monthly',
                price: 499,
                dollar_price: 4.99,
                description: 'This is the description of Insider Monthly (test scenario)',
                id: 123,
                product_sku: 'insider_monthly',
                period: 'monthly',
                rank: 0
            }
        }
    }, {
        id: 'staff-nonmember',
        label: 'Staff',
        description: `
            Staff user who has never had a membership
        `,
        membership: null,
        user: { staff: true }
    }, {
        id: 'introductory',
        label: 'Introductory Pricing Period',
        description: `
            The user is currently in an introductory pricing period
        `,
        membership: {
            gateway_name: 'stripe',
            purchased_at: new Date(Date.now()-1000*60*60*24*35).toISOString(),
            entitled: <any>true,
            active: true,
            payment_source: 'Mastercard **1234',
            payment_status: 'canceling',
            renews_on: new Date(Date.now()+1000*60*60*24*25).toISOString(),
            introductory_periods: 3,
            introductory_price: 199,
            price: 199,
            status: <any><Partial<ApiGatewayMembershipStatus>>{
                renewal_due_date: new Date(Date.now()+1000*60*60*24*5).toISOString(),
                next_charge_amount: 199,
                next_charge_date: new Date(Date.now()+1000*60*60*24*5).toISOString(),
                in_good_standing: true,
                canceled: false,
                cancel_at_period_end: false,
                past_due: false
            },
            product: <any><Partial<ApiMembershipProduct>>{
                name: 'Insider Monthly',
                price: 499,
                dollar_price: 4.99,
                description: 'This is the description of Insider Monthly (test scenario)',
                id: 123,
                product_sku: 'insider_monthly',
                period: 'monthly',
                rank: 0
            }
        }
    }, {
        id: 'introductory',
        label: 'Introductory Pricing Period Elapsed',
        description: `
            The user has a membership with introductory pricing, but the
            intro pricing period has elapsed
        `,
        membership: {
            gateway_name: 'stripe',
            purchased_at: new Date(Date.now()-1000*60*60*24*95).toISOString(),
            entitled: <any>true,
            active: true,
            payment_source: 'Mastercard **1234',
            payment_status: 'canceling',
            renews_on: new Date(Date.now()+1000*60*60*24*25).toISOString(),
            introductory_periods: 3,
            introductory_price: 199,
            price: 199,
            status: <any><Partial<ApiGatewayMembershipStatus>>{
                renewal_due_date: new Date(Date.now()+1000*60*60*24*5).toISOString(),
                next_charge_amount: 499,
                next_charge_date: new Date(Date.now()+1000*60*60*24*5).toISOString(),
                in_good_standing: true,
                canceled: false,
                cancel_at_period_end: false,
                past_due: false
            },
            product: <any><Partial<ApiMembershipProduct>>{
                name: 'Insider Monthly',
                price: 499,
                dollar_price: 4.99,
                description: 'This is the description of Insider Monthly (test scenario)',
                id: 123,
                product_sku: 'insider_monthly',
                period: 'monthly',
                rank: 0
            }
        }
    }, {
        id: 'gplay-member',
        label: 'GPlay $4.99/mo',
        description: `
            User has an active membership via Google Play.
        `,
        membership: {
            gateway_name: 'google_play',
            purchased_at: '2020-11-15',
            entitled: <any>true,
            active: true,
            payment_source: 'Google Account',
            status: <any><Partial<ApiGatewayMembershipStatus>>{
                renewal_due_date: new Date(Date.now() + 1000 * 60 * 60 * 24 * 5).toISOString(),
                next_charge_amount: 499,
                next_charge_date: new Date(Date.now() + 1000 * 60 * 60 * 24 * 5).toISOString(),
            },
            product: <any><Partial<ApiMembershipProduct>>{
                name: 'Insider Monthly',
                price: 499,
                dollar_price: 4.99,
                description: 'This is the description of Insider Monthly (test scenario)',
                id: 123,
                product_sku: 'insider_monthly',
                period: 'monthly',
                rank: 0
            }
        }
    }, {
        id: 'iap-member',
        label: 'App Store $4.99/mo',
        description: `
            User has an active membership via Google Play.
        `,
        membership: {
            gateway_name: 'iap_apple',
            purchased_at: '2020-11-15',
            entitled: <any>true,
            active: true,
            payment_source: 'App Store',
            status: <any><Partial<ApiGatewayMembershipStatus>>{
                renewal_due_date: new Date(Date.now() + 1000 * 60 * 60 * 24 * 5).toISOString(),
                next_charge_amount: 499,
                next_charge_date: new Date(Date.now() + 1000 * 60 * 60 * 24 * 5).toISOString(),
            },
            product: <any><Partial<ApiMembershipProduct>>{
                name: 'Insider Monthly',
                price: 499,
                dollar_price: 4.99,
                description: 'This is the description of Insider Monthly (test scenario)',
                id: 123,
                product_sku: 'insider_monthly',
                period: 'monthly',
                rank: 0
            }
        }
    }, {
        id: 'actblue-member',
        label: 'ActBlue $4.99/mo',
        description: `
            User has an active membership via ActBlue.
        `,
        membership: {
            gateway_name: 'actblue',
            purchased_at: '2024-02-05',
            entitled: <any>true,
            active: true,
            payment_source: 'ActBlue Account',
            status: <any><Partial<ApiGatewayMembershipStatus>>{
                renewal_due_date: new Date(Date.now() + 1000 * 60 * 60 * 24 * 5).toISOString(),
                next_charge_amount: 499,
                next_charge_date: new Date(Date.now() + 1000 * 60 * 60 * 24 * 5).toISOString(),
            },
            product: <any><Partial<ApiMembershipProduct>>{
                name: 'Insider Monthly',
                price: 499,
                dollar_price: 4.99,
                description: 'This is the description of Insider Monthly (test scenario)',
                id: 123,
                product_sku: 'insider_monthly',
                period: 'monthly',
                rank: 0
            }
        }
    }, {
        id: 'broken',
        label: 'Missing GMS (Broken)',
        description: `
            API failed to return Gateway Membership Status for the user's
            gateway.
        `,
        membership: {
            gateway_name: 'stripe'
        },
    }, {
        id: 'paypal_subscription',
        label: 'PayPal Legacy',
        description: `
            User has a legacy PayPal membership (PayPal Subscriptions)
        `,
        membership: {
            gateway_name: 'paypal_subscription',
            purchased_at: '2016-11-15',
            entitled: <any>true,
            active: true,
            payment_source: 'PayPal Account (johndoe@example.com)',
            payment_status: 'good_standing',
            renews_on: new Date(Date.now()-1000*60*60*24*2).toISOString(),
            price: null,
            status: <any><Partial<ApiGatewayMembershipStatus>>{
                "gateway":"paypal_subscription",
                "renewal_due_date":"2018-11-19T03:32:42.000-08:00",
                "canceled":false,
                "cancel_at_period_end":false,
                "cancel_date":null
            },
            product: <any><Partial<ApiMembershipProduct>>{
                name: 'Activist Monthly',
                price: 1000,
                dollar_price: 10.00,
                description: 'This is the description of Activist Monthly (test scenario)',
                id: 123,
                product_sku: 'activist_monthly',
                period: 'monthly',
                rank: 0
            }
        }
    }
];